import {BookingForm} from "@/components/booking/BookingForm.tsx";
import BrandHeader from "@/components/booking/BrandHeader.tsx";
import {useContext} from "react";
import {OscarContext, OscarContextType} from "@/components/context/OscarContext.tsx";
import {BookingConfirmation} from "@/components/booking/BookingConfirmation.tsx";
import {CommunityBookingForm} from "@/components/booking/CommunityBookingForm.tsx";
import {CommunityBookingConfirmation} from "@/components/booking/CommunityBookingConfirmation.tsx";

function App() {
    const { localConfig, finalBooking } = useContext(OscarContext) as OscarContextType

    return (
        <div className="os-flex os-flex-col os-gap-4">
            {localConfig.showHeader && <BrandHeader /> }
            {finalBooking && !localConfig.communityBooking && (
                <BookingConfirmation booking={finalBooking} />
            )}
            {!finalBooking && !localConfig.communityBooking && (
                <BookingForm />
            )}
            {finalBooking && localConfig.communityBooking && (
                <CommunityBookingConfirmation />
            )}
            {!finalBooking && localConfig.communityBooking && (
                <CommunityBookingForm />
            )}
        </div>
    )
}

export default App
